var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"top-title"},[_vm._v("LIFE DESIGN COURSE")]),_c('h1',[_c('span',[_vm._v(_vm._s(_vm.userNick))]),_vm._v(" 님의 생애연표 ")]),_c('p',{staticClass:"body-2"},[_vm._v(_vm._s(_vm.userEmail))])])}
var staticRenderFns = []

export { render, staticRenderFns }